import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { SEO } from "../components/SEO";
import { API, LOGO_MARK } from "../lib/site";
import { MEMBER_TOKEN_KEY } from "./MemberRegister";

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        // One-time session exchange — ref guard prevents a double exchange under StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
        if (!sessionId) {
            setError("Missing sign-in session. Please try again.");
            return;
        }
        (async () => {
            try {
                const { data } = await axios.post(`${API}/members/google/session`, {
                    session_id: sessionId,
                });
                localStorage.setItem(MEMBER_TOKEN_KEY, data.token);
                navigate("/member/dashboard", { replace: true });
            } catch {
                setError("We couldn't complete your Google sign-in. Please try again.");
            }
        })();
    }, [location.hash, navigate]);

    return (
        <main>
            <SEO title="Signing you in | Global Green Hotel" description="Completing your Google sign-in." />
            <div className="grain flex min-h-screen items-center justify-center bg-[#04150D] px-5 py-32">
                <div
                    data-testid="auth-callback"
                    className="w-full max-w-md rounded-2xl border border-white/10 bg-[#07211A] p-9 text-center"
                >
                    <img src={LOGO_MARK} alt="Global Green Hotel logo" className="mx-auto w-36" />
                    {error ? (
                        <>
                            <p data-testid="auth-callback-error" role="alert" className="mt-7 text-sm font-semibold text-[#E8A0A0]">
                                {error}
                            </p>
                            <Link to="/login?tab=member" data-testid="auth-callback-retry" className="btn-gold mt-7">
                                Back to Sign In
                            </Link>
                        </>
                    ) : (
                        <>
                            <div
                                className="mx-auto mt-8 h-10 w-10 animate-spin rounded-full border-2 border-[#C2A160]/30 border-t-[#C2A160]"
                                aria-hidden="true"
                            />
                            <p className="mt-6 text-sm text-[#FDFBF7]/70">Completing your sign-in…</p>
                        </>
                    )}
                </div>
            </div>
        </main>
    );
};

export default AuthCallback;
